/**
 * The backend's own words when it refused a write, so the operator knows why
 * rather than being told only that something failed.
 */
export function saveErrorMessage(error: unknown): string {
    const message = (
        error as { response?: { data?: { message?: string | string[] } } } | null
    )?.response?.data?.message;
    // class-validator sends one message per failed rule, so a rejected DTO
    // arrives as an array.
    if (Array.isArray(message)) return message.join(' · ');
    return message ?? String(error);
}
